import { ReactElement } from 'react'
import { TextAreaField } from '@components/TextField'
import { FormHeader } from './layout'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { Goal } from '../../constants'
export const InstructionsSection = (): ReactElement => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const formik = useFormikContext<Goal>()
  const { instruction } = formik.values
  const { isDisabled } = formik.status
  const handleChange = (value: string) => {
    setValue(value)
    formik.setFieldValue('instruction', value)
  }
  const maxLength = 3000

  return (
    <div className='pb-6 pt-8 gap-2'>
      <FormHeader
        title={t('instructionsLabel')}
        description={t('assigneeLabel')}
      />
      <TextAreaField
        data-testid="instructions-text-area"
        className="max-w-xl"
        label={t('instructionsLabel')}
        name="instructions"
        isDisabled={isDisabled}
        value={instruction}
        errorMessage={formik.errors.instruction}
        rows={12}
        resize='none'
        maxLength={maxLength}
        onChange={handleChange}
      />
      {`${t('charactersRemainingv2')} ${maxLength - value.length}`}
    </div>
  )
}
